import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { isTokenValid } from '../../utilities/auth';

// Guards routes that require an authenticated user. A token only counts if it's a
// well-formed, unexpired JWT — a stale/junk token (e.g. "null", malformed, or
// expired) is treated as logged-out and purged, so the user is bounced to the
// login screen instead of mounting the app and hitting a "no email" API error.
//
// We subscribe to the redux token so a logout dispatched elsewhere (e.g. the 401
// handler in playerInfoSlice) re-renders this guard and redirects immediately.
const ProtectedRoute = () => {
    const reduxToken = useSelector((state) => state.auth.token);
    const token = reduxToken ?? localStorage.getItem("token");

    if (!isTokenValid(token)) {
        localStorage.removeItem("token");
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
